import script from "./PaymentMethodPaypal.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodPaypal.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodPaypal.vue?vue&type=style&index=0&id=0e83bbf0&scoped=true&lang=css"

import exportComponent from "C:\\development\\ON\\montalvo.ti\\dish-frontend-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e83bbf0"]])

export default __exports__